export const SET_CALENDAR_RECOMMENDATIONS_LOADING = "SET_CALENDAR_RECOMMENDATIONS_LOADING";
export const SET_CALENDAR_RECOMMENDATIONS_SUCCESS = "SET_CALENDAR_RECOMMENDATIONS_SUCCESS";
export const SET_CALENDAR_RECOMMENDATIONS_ERROR = "SET_CALENDAR_RECOMMENDATIONS_ERROR";
export const SET_FAN_CONVERT_LOADING = "SET_FAN_CONVERT_LOADING";
export const SET_FAN_CONVERT_SUCCESS = "SET_FAN_CONVERT_SUCCESS";
export const SET_FAN_CONVERT_ERROR = "SET_FAN_CONVERT_ERROR";
export const RESET_FAN_CONVERT = "RESET_FAN_CONVERT";